import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';
import { ProductDisplay } from './ProductDisplay';
import { ProductConfig } from './ProductConfigurator';
import { useGetProductQuery } from '../../api/productApi';
import { Product } from '../../types/product';

export const ProductDisplayWrapper: React.FC = () => {
  const { productId } = useParams<{ productId: string }>();
  const { data: product, isLoading, error } = useGetProductQuery(productId!);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (error || !product) {
    return (
      <Box p={3}>
        <Typography variant="h6" color="error">
          Product not found or error loading product.
        </Typography>
      </Box>
    );
  }

  const handleConfigure = (config: ProductConfig) => {
    console.log('Configuration saved:', config);
    // Handle configuration logic here
  };

  return (
    <ProductDisplay
      product={product as Product}
      onConfigure={handleConfigure}
    />
  );
}; 